<!--
 * @Description: 查看对账函回复弹框
 * @Autor: txp
 * @Date: 2021-05-07 15:57:39
-->
<template>
    <div class="dialogcom">
        <el-dialog
            :title="titles"
            :visible.sync="dialogVisible"
            width="40%"
            :lock-scroll="false"
            :destroy-on-close="true"
            :before-close="handleClose">
           <div>
               <!-- 有反馈信息的情况 -->
              <div v-if="dataInfo.customerFeedback">
                    <div class="mtb20 info_cont ft14">
                        <div class="info_cont_title flex">
                            <div class="flex">
                                <p class="D1D1D1">回复人姓名：</p>
                                <p>{{dataInfo.replyUserName}}</p>
                            </div>
                            <!-- <div class="flex">
                                <p class="D1D1D1">客户反馈：</p>
                                <p>{{dataInfo.customerFeedback}}</p>
                            </div> -->
                            <div class="flex">
                                <p class="D1D1D1">回复时间：</p>
                                <p>{{dataInfo.feedbackTime}}</p>
                            </div>
                        </div>
                        <div class="info_cont_cont mt20">
                            <p class="D1D1D1">回复内容：</p>
                            <div class="info_bor text-indent1">
                                {{dataInfo.reply}}
                            </div>
                        </div>
                    </div>
              </div>
              <!-- 无反馈信息 -->
              <div v-else>
                  暂无反馈信息...
              </div>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="Save">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:{
        visible: { //是否显示
            type: Boolean,
            default: false
        },
        titles:{
            type:String,
            default:""
        },
        dataInfo:{
            type:Object,
            default:function(){
                return {}
            }
        }
    },
    data(){
        return{
            flag:true
        }
    },
    computed:{
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
            }
        }
    },
    methods:{
        // 获取反馈信息
        info(){

        },
        // 关闭
        handleClose () {
            this.$emit('handleClose',false)
        },
        // 确定
        Save() {
            this.$emit('submitPopupData',false)
        },
    }
}
</script>
<style lang="scss" scoped>
    .dialogcom{
        /deep/ .el-dialog__footer{
        text-align: center;
        }
        /deep/.el-button--small{
            width: 120px;
        }
        /deep/.el-dialog__body{
            padding: 10px 20px;
        }
        .info_cont{
            border: 1px solid #787878;
            border-radius: 10px;
            padding: 10px;
            .info_bor{
                // padding: 10px;
                // border: 1px solid #787878;
                line-height: 30px;
            }
        }
    }
   .flex{
       margin-right: 40px;
   }
</style>
